import channelmatrix from "../services/reports.channel";
import notification from "../services/notification";

export default {
    namespaced: true,

    state: {
        loading: false,
        error: false,
        errors: {},
        list: [],
        filters: [],
        param: {
            param: {
                keyword: null,
                filter: null,
                year: new Date().getFullYear().toString()
            },
            page: 1
        },
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        },
        import: false,
        importfile: null,
        importBase: null,
        uploading: false,
        confirm: false,
        data_errors: null
    },

    mutations: {
        loading(state, status) {
            state.loading = status;
        },
        errors(state, errors) {
            state.error = true;
            state.errors = errors.errors;
        },
        setParam(state, param) {
            state.loading = true;
            state.param = param;
            state.loading = false;
        },
        setList(state, list) {
            state.list = list;
        },
        setFilters(state, filters) {
            state.filters = filters;
        },
        setUploading(state, status) {
            state.uploading = status;
        },
        setImportChannel(state, importfile) {
            state.importfile = importfile;
        },
        setImportChannelBase(state, importBase) {
            state.importBase = importBase.split(",").pop();
            state.import = true;
        },
        setImportChannelDefault(state) {
            state.importBase = null;
            state.import = false;
        },
        setConfirmModal(state, status) {
            state.confirm = status;
        },
        setInitialPageCount(state, list) {
            state.pagination.initialPageCount = list.length;
        },
        setCurrentPage(state, page) {
            state.pagination.currentPage = page;
        },
        setPagination(state, pagination) {
            state.pagination.totalPerPage = pagination.list.length;
            state.pagination.maxPage = state.pagination.totalPerPage > 0 ? pagination.max_page : 0;
            state.pagination.prevPage = pagination.prev_page;
            state.pagination.nextPage = pagination.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.totalPerPage > 0
                    ? state.pagination.initialPageCount * state.pagination.prevPage + 1
                    : 0;
            state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem + state.pagination.totalPerPage - 1
                    : 0;
        },
        setMismatchRows(state, rows) {
            if (rows !== null) {
                state.data_errors = {
                    field_errors: rows.field_errors,
                    mismatch_col: rows.mismatch_col,
                };
            } else {
                state.data_errors = rows;
            }
        }
    },

    actions: {
        getList: async ({ commit }, param) => {
            commit("loading", true);
            try {
                let response = await channelmatrix.getList(param);

                if (param.page === 1) {
                    await commit("setInitialPageCount", response.list);
                }
                
                commit("setList", response.list);
                commit("setPagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
            }
        },

        exportXls: async ({ commit }, param) => {
            commit("loading", true);
            try {
                let response = await channelmatrix.exportXls(param);
                commit("loading", false);
                notification.success(response.message);
                window.open(response.url);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        exportPdf: async ({ commit }, param) => {
            commit("loading", true);
            try {
                let response = await channelmatrix.exportPdf(param);
                commit("loading", false);
                notification.success(response.message);
                window.open(response.url);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        importChannel: async ({ commit, state }) => {
            commit("loading", true);
            // commit("setUploading", true);
            notification.info("File is currently uploading");
            try {
                let response = await channelmatrix.importChannel({
                    tsv: state.importBase
                });
                // let status = response.stats;

                // if (
                //     status.success > 0 &&
                //     status.errors.field_errors.length === 0 &&
                //     status.errors.mismatch_col.length === 0
                // ) {
                //     notification.success(response.message);
                // } else if (
                //     status.errors.field_errors.length === 0 &&
                //     status.errors.mismatch_col.length === 0 &&
                //     status.success === 0
                // ) {
                //     notification.warning(
                //         "You have entered an invalid format. Please check the format and try again."
                //     );
                // } else {
                //     await commit("setMismatchRows", status.errors);
                //     notification.warning(
                //         "You have an invalid field within the tsv file. Please check the file and try again."
                //     );
                // }

                commit("setImportChannelDefault");
                commit("loading", false);
                commit("setUploading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                commit("setUploading", false);
                notification.warning("Oops, cannot upload Channel Matrix.");
            }
        },

        readImportChannel: async ({ commit, state }) => {
            commit("loading", true);

            let reader = new FileReader();
            reader.readAsDataURL(state.importfile);

            reader.onload = e => {
                commit("setImportChannelBase",
                e.target.result.substring(21));
            }
        },

        getFilters: async ({ commit }) => {
            try {
                let response = await channelmatrix.getFilters();
                commit("setFilters", response);
            } catch (errors) {
                commit("errors", errors);
            }
        }
    }
}